import React from 'react';
import PropTypes from 'prop-types';
import { TeamWatermarkBackground } from '../../TeamWatermarkBackground';
import { getTranslation } from '../../../../../../../common/react/utils/translations';
import { SvgIcon } from '../../../../../../../common/react/components/SvgIcon';

/**
 * @param {object} props - Props.
 * @param {Array} props.players - Players details.
 * @param {string} props.position - Players position.
 * @returns {JSX.Element} Component.
 */
export const FeaturedHeadToHeadCardTop = ({ players, position }) => (
    <div className="stats-card-featured-player">
        <div className="stats-card-featured-player__inner-container">
            {players.map((player, i) => (
                <div
                    className="stats-card-featured-player__image-container"
                    key={i}
                >
                    <TeamWatermarkBackground
                        teamAbbreviation={player.team.teamAbbr}
                        className="stats-card-featured-player__bg stats-card-featured-player__bg--no-border-radius"
                        side={i === 0 ? 'left' : 'right'}
                    />
                    <div className="stats-card-featured-player__photo-container">
                        <img
                            className="stats-card-featured-player__image"
                            alt={`${getTranslation(
                                'label.stats.headshot.alt'
                            )} ${player.playerDetails.givenName} ${
                                player.playerDetails.surname
                            }`}
                            src={player.playerDetails.photoURL}
                        />
                    </div>
                </div>
            ))}

            <div className="stats-card-featured-player__versus">
                <SvgIcon
                    icon="versus-white"
                    className="icon"
                    folder="elements"
                    subfolder="stats"
                />
            </div>

            <div className="stats-card-featured-player__category-outer-wrapper">
                <div className="stats-card-featured-player__category-container">
                    <p className="stats-card-featured-player__category">
                        {getTranslation('label.stats.' + position)}
                    </p>
                </div>
            </div>
        </div>
    </div>
);

FeaturedHeadToHeadCardTop.propTypes = {
    players: PropTypes.array.isRequired,
    position: PropTypes.string.isRequired
};
